import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DocumentTitle from 'src/components/DocumentTitle/DocumentTitle';
import Page from 'src/components/Page/Page';
import useDocumentTitle from 'src/hooks/use-document-title';
import saveAs from 'file-saver';
import TertiaryButton from 'src/components/TertiaryButton/TertiaryButton';
import { useSivaContractDataExtract } from 'src/features/siva/ideas-and-companies/hooks/use-siva-contract-data-extract';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import { Select, SelectOptionProps } from '@innovationnorway/component-library';
import useSivaYearList from 'src/hooks/use-year-list-reporting';

const ExtractIdeasAndCompanies: React.FC = () => {
  const { t: tPageTitles } = useTranslation('pageTitles');
  const { t: tSiva } = useTranslation('siva');
  const { t: tCommon } = useTranslation('common');
  const { documentTitle } = useDocumentTitle(tPageTitles('sivaReporting'));

  const [selectedYear, setSelectedYear] = useState<string | undefined>(undefined);
  const yearList = useSivaYearList(2023);

  const { downloadAllData } = useSivaContractDataExtract(
    selectedYear === '' ? undefined : parseInt(selectedYear || ''),
  );

  const yearOptions: SelectOptionProps[] = React.useMemo(() => {
    return [{ value: '', text: 'Alle år' }].concat(
      yearList.map((item) => ({ value: item.toString(), text: item.toString() })),
    );
  }, [yearList]);

  return (
    <DocumentTitle title={documentTitle}>
      {downloadAllData.isLoading ? (
        <LoadingPage />
      ) : (
        <Page>
          <div className="stack-large">
            <h1>{tSiva('export.ideasAndCompanies.header')}</h1>
            <Select
              value={selectedYear}
              className="margin-0-on-all-children"
              label="Totalrapport for"
              name="year"
              hideError
              placeholder={tCommon('selectYear')}
              options={yearOptions}
              onChange={setSelectedYear}
            />
            <TertiaryButton
              onClick={async () => {
                const file = await downloadAllData.mutateAsync(true);
                saveAs(file.data, file.fileName);
              }}
              minimalPadding={true}
              disabled={selectedYear === undefined}
              icon={{ prefix: 'fal', iconName: 'file-export' }}
            >
              {tSiva('export.ideasAndCompanies.exportButton')}
            </TertiaryButton>
          </div>
        </Page>
      )}
    </DocumentTitle>
  );
};

export default ExtractIdeasAndCompanies;
